import polyglotI18nProvider from "ra-i18n-polyglot";
import frenchMessages from "ra-language-french";
import { RESOURCE_LABELS } from "./layout/menuConfig";

// Libellés FR des champs communs (utilisés quand un champ n'a pas de label
// explicite : sinon react-admin afficherait le nom technique « humanisé »).
export const FIELD_LABELS = {
  id: "Identifiant",
  name: "Nom",
  title: "Titre",
  description: "Description",
  content: "Contenu",
  createdAt: "Créé le",
  updatedAt: "Modifié le",
  creationDate: "Inscrit le",
  status: "Statut",
  email: "Email",
  phone: "Téléphone",
  phoneNumber: "Téléphone",
  firstName: "Prénom",
  lastName: "Nom",
  type: "Type",
  category: "Catégorie",
  theme: "Thème",
  startAt: "Début",
  endAt: "Fin",
  startDate: "Début",
  endDate: "Fin",
  note: "Note",
  rating: "Note",
  enabled: "Activé",
  brand: "Marque",
  authorType: "Type d'auteur",
  authorId: "Auteur",
  patientId: "Patient",
  proId: "Professionnel",
  professionalId: "Professionnel",
  userId: "Utilisateur",
  bookingId: "Rendez-vous",
  amount: "Montant",
  price: "Prix",
  videoUrl: "Vidéo",
  usedSessions: "Séances utilisées",
  totalSessions: "Séances au total",
  score: "Score",
  roomId: "Salle",
  proches: "Proches",
  presentielOnly: "Présentiel uniquement",
  mimeType: "Type de fichier",
  location: "Lieu",
  job: "Métier",
  gender: "Genre",
  exercisesCount: "Exercices",
  domainMedical: "Domaine médical",
  code: "Code",
  cabinet: "Cabinet",
  averageDurationMinutes: "Durée moyenne (min)",
  professionals: "Professionnels",
  patients: "Patients",
  q: "Rechercher",
  value: "Valeur",
  kind: "Type",
  label: "Libellé",
  points: "Points",
  reason: "Motif",
  message: "Message",
  subject: "Objet",
  sentAt: "Envoyé le",
  read: "Lu",
  active: "Actif",
  published: "Publié",
  city: "Ville",
};

const resources = Object.fromEntries(
  Object.entries(RESOURCE_LABELS).map(([r, label]) => [r, { name: `${label} |||| ${label}`, fields: FIELD_LABELS }])
);

// Interface react-admin entièrement en français (boutons, pagination,
// filtres, notifications…). Quelques libellés ajustés au vocabulaire ioUman.
const messages = {
  ...frenchMessages,
  resources,
  ra: {
    ...frenchMessages.ra,
    page: {
      ...frenchMessages.ra.page,
      dashboard: "Tableau de bord",
      empty: "Aucun élément pour le moment",
      invite: "",
    },
    auth: {
      ...frenchMessages.ra.auth,
      user_menu: "Mon compte",
    },
  },
};

export const i18nProvider = polyglotI18nProvider(() => messages, "fr", [{ locale: "fr", name: "Français" }], {
  allowMissing: true,
});

export default i18nProvider;
